import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { WorkLineDto } from '@app/generated/model';
import { WorkLineModel, WorkOrderObjectModel } from '@app/work-order/objects/work-order-object.model';
import { QuantityDialogComponent } from '@app/shared/quantity-dialog/quantity-dialog.component';
import { first } from 'rxjs/operators';

import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmComponent } from '@app/shared/confirm/confirm.component';
import { ConfirmDialogModel } from '@app/shared/confirm/confirm-dialog.model';
import { Store } from '@ngrx/store';
import { MarkWorkLineAsComplete, ReOpenWorkLine, UpdateWorkLineQuantity } from '@dwo/actions';

@Component({
  selector: 'app-work-line-quantity',
  templateUrl: './work-line-quantity.component.html',
  styleUrls: ['./work-line-quantity.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WorkLineQuantityComponent implements OnInit {
  @Input() workLine: WorkLineDto;
  @Output() selected = new EventEmitter<WorkOrderObjectModel>();

  public selectedChildren: WorkOrderObjectModel[];
  public indentationPerStep = 18;
  public level = 0;
  public indentationStartingPoint = 20;
  public isClickable: boolean = false;
  constructor(
    private store: Store,
    private translateService: TranslateService,

    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.selectedChildren = [];
    const progressType = this.workLine?.progressType;
    this.isClickable = progressType === '1' || progressType === '2';
  }

  showQuantityDialog(workLine: WorkLineDto) {
    if (workLine.completed) {
      return;
    }

    const dialog = this.dialog.open(QuantityDialogComponent, {
      data: { quantity: workLine.installedQuantity, total: workLine.plannedQuantity, unit: workLine.unit },
    });

    dialog
      .afterClosed()
      .pipe(first())
      .subscribe((result) => {
        if (!result) {
          return;
        }
        this.store.dispatch(new UpdateWorkLineQuantity(workLine.id, result.quantity));
      });
  }

  markAsReopened(workLine: WorkLineDto) {
    const message = this.translateService.instant('workOrderLines.confirmReOpenWarning');
    const confirmMessage = workLine.title;

    const dialog = this.dialog.open(ConfirmComponent, {
      data: {
        message,
        confirmMessage,
      } as ConfirmDialogModel,
    });

    dialog
      .afterClosed()
      .pipe(first())
      .subscribe((result) => {
        if (!result) {
          return;
        }
        this.store.dispatch(new ReOpenWorkLine(workLine.id));
      });
  }

  markAsComplete(workLine: WorkLineDto) {
    if (workLine.completed) {
      return;
    }
    if (!workLine.installedQuantity) {
      workLine.installedQuantity = workLine.plannedQuantity;
      workLine.completed = true;
      this.store.dispatch(new UpdateWorkLineQuantity(workLine.id, workLine.installedQuantity));
      this.store.dispatch(new MarkWorkLineAsComplete(workLine.id));
      return;
    }

    const message = this.translateService.instant('workOrderLines.confirmWarning', {
      quantity: workLine.installedQuantity,
      plannedQuantity: workLine.plannedQuantity,
    });
    const confirmMessage = this.translateService.instant('workOrderLines.confirmComplete');

    const dialog = this.dialog.open(ConfirmComponent, {
      data: {
        message,
        confirmMessage,
      } as ConfirmDialogModel,
    });

    dialog
      .afterClosed()
      .pipe(first())
      .subscribe((result) => {
        if (!result) {
          return;
        }
        this.store.dispatch(new MarkWorkLineAsComplete(workLine.id));
      });
  }

  public toggleSelectedWorkLine(workLine: WorkLineModel) {
    workLine.isSelected = !workLine.isSelected;
    if (!workLine.isSelected) {
      //this.workOrderObjectService.addSelectedWorkLine(workLine);
    } else {
      //this.workOrderObjectService.removeSelectedWorkLine(workLine);
    }
  }

  public getIndentation(): number {
    return this.indentationStartingPoint + this.indentationPerStep * this.level + this.indentationPerStep;
  }
}
